<template>
   <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-card>
        <v-card-title>
          <span class="headline">Profielgegevens</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field label="E-mail*" v-model="relation.email" required autofocus @blur="setEmailAddress" :rules="[rules.required ,rules.emailRule]"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 v-if="extend">
                <v-text-field label="Bedrijfsnaam*" v-model="relation.name" required :rules="[rules.required]"></v-text-field>
              </v-flex>
                <v-flex xs12  sm6 v-if="extend">
                <v-text-field label="website" v-model="relation.website" required :rules="[rules.required]"></v-text-field>
              </v-flex>
              <v-flex xs10 sm8 md8 v-if="extend">
                <v-text-field label="Uw naam*" v-model="contact.name" required hint="Geef uw volledige naam" @blur="setContactName" autofocus :rules="[rules.required]"></v-text-field>
              </v-flex>
               <v-flex xs2 sm4 md4 v-if="contact.name">
               <v-select
                  :items="[{id: 'unknown', name: 'Onbekend'},{id: 'male', name: 'Man'},{id: 'female', name: 'Vrouw'}]"
                  item-text="name"
                  item-value="id"
                  label="Geslacht*"
                   :rules="[rules.required]"
                ></v-select>
              </v-flex>
              </v-layout>
               <v-layout wrap v-if="contact.last_name">
               <v-flex xs12 sm6 md4 v-if="contact.first_name">
                <v-text-field label="Voornaam" v-model="contact.first_name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 v-else>
                <v-text-field label="Initialen" v-model="contact.initials"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field label="Tussenvoegsels" v-model="contact.middle_name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field label="Achternaam" v-model="contact.last_name"></v-text-field>
              </v-flex>
               </v-layout>
               <v-layout wrap>
            
              
              <v-flex xs12>
              <v-combobox
                v-model="selected"
                :items="list"
                item-text="name"
                item-value="name"
                label="Labels"
                chips
                clearable
                solo
                multiple
                small
                flat
              >
                <template v-slot:selection="data">
                  <v-chip
                    label outline
                    :selected="data.selected"
                    :close="data.hover"
                    @input="removeSelected(data.item)"
                    @mouseover="data.hover = true"
                    @mouseleave="data.hover = false"
                  > <v-avatar>
                      <v-icon small>icon icon-{{data.item.icon}}</v-icon>
                    </v-avatar>
                    <strong>{{ data.item.name }}</strong>&nbsp;
                    <span>({{ data.item.type }}){{data.hover}}</span>
                  </v-chip>
                </template>
              </v-combobox>
              </v-flex>
              <v-flex xs12 v-if="extend">
              <v-textarea
                  v-model="relation.description"
                  label="Opmerking"
                  auto-grow
                  value=""
                ></v-textarea>
                </v-flex>
            </v-layout>
          </v-container>
          <small>*Verplichte velden</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="close">Annuleren</v-btn>
          <v-btn color="blue darken-1" flat @click="save">Opslaan</v-btn>
        </v-card-actions>
      </v-card>
      </v-form>
</template>

<script>

import {
  mapMutations,
  mapGetters,
  mapState
} from 'vuex'

export default {
  data: () => ({
     valid: true,
     rules: {
          required: value => !!value || 'Verplicht.',
          emailRule: v => /.+\@.+\..+/.test(v) || 'Vul een geldig E-mail adres in',
          min: v => v.length >= 8 || 'Minimaal 8 characters',
          emailMatch: () => ('Het E-mail adres of wachtwoord wordt niet herkend')
        },
     //relation: {},
     //contact: {},
     extend: false
     
    }),
  computed: {
    ...mapGetters('relation',['relation','contacts']),
     //...mapGetters('auth', ['relation','user']),
     ...mapGetters('tag',['list','selectedTags']),
     contact(){
       return this.contacts[0]
     },
    selected: {
        get () { return this.selectedTags},
        set (value) { this.setSelected(value) }
     }
    },
  
  created () {
   console.log('mount',this.relation)
  },
  watch: {
    'contact' (val,prevVal) {
     // if (val.name && val.name != prevVal.name) this.setContactName(val.name)
    }
  },
  beforeDestroy () {
   
  },

  methods: {
    ...mapMutations('relation', ['setRelation','setContacts']),
    ...mapMutations('tag', ['setSelected','removeSelected']),
    changeContact () {
      
    },
    validate () {
        this.valid = this.$refs.form.validate()
        return this.valid
      },
    close () {
      this.$emit('close')
    },
    save () {
      console.log(this.relation)
     if (this.validate()) {
       this.setContacts([this.contact])
       this.setRelation(this.relation)
        this.$emit('close')
     }
      //this.$emit('close')
    },
    setEmailAddress () {
      if (!this.relation.email) return false
      if (this.relation.email.indexOf('@') == -1) return false
      var domain = this.relation.email.split('@')[1]
      this.relation.website = 'www.' + domain
      if (this.relation.name + '' != '') this.relation.name = domain.split('.')[0].capitalize()
      this.extend = true
    },
     setContactName () {
       if (!this.contact.name) return false
        var name = this.contact.name
        console.log(name)
    		var gender = this.contact.gender || 'unknown'
    		if (name.indexOf('Dhr.')>-1) gender = 'male'
    		if (name.indexOf('Mw.')>-1) gender = 'female'
    		name = name.replace('Dhr. ','').replace('Mw. ','')
    		var sname = name
    		console.log(sname)
        var names = sname.split(' ');
    		 var initials,first,middle,last
            if (names.length == 1) { 
               last = names[0];
            } else {
                if (names[0].indexOf('.') > -1) {
                    initials = names[0].toUpperCase();
                } else {
                    first = names[0].capitalize();
                    initials = names[0].substring(0, 1).toUpperCase() + '.';
                }
                if (names.length > 2) {
                    var middle = '';
                    for (var i = 1; i < names.length - 1; i++) {
                        middle += names[i] + " ";
                    }
                     middle = middle.toLowerCase();
                }
               
                last = names[names.length - 1].capitalize();
            }
            console.log(name, first,last)
          this.contact = {
          		  name: name,
          		  initials: initials,
          		  first_name: first,
          		  middle_name: middle, 
          		  last_name : last,
          		  gender : gender,
          		  email: this.relation.email
              }
          
          
   }
  }
}

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1)
}
</script>
<style>

</style>